module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "start",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.payment.receivable.marking_minified.markingheadercode) + "\n                "), _c('hr'), _vm._v("\n                " + _vm._s(_vm._f("dateFormatted")(_vm.payment.paymentDate)) + "\n                "), _c('h5', [_vm._v(_vm._s(_vm.payment.receivable.description))])]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Tag', {
    attrs: {
      "type": "border",
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("numberFormatted")(_vm.payment.amount)) + " ")])], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.onSelectedPayment()
      }
    }
  }, [_c('span', [_vm._v("Select")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c905102","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentRow.vue
// module id = 1837
// module chunks = 1